/* unplugin-vue-components disabled */import script from "./Invoiced.vue?vue&type=script&setup=true&name=Invoiced&lang=js"
export * from "./Invoiced.vue?vue&type=script&setup=true&name=Invoiced&lang=js"

const __exports__ = script;

export default __exports__